/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Tools_Title5Inputs */

const en_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool integrations`)
};

const ar_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكامل الأدوات`)
};

const bn_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুল ইন্টিগ্রেশন`)
};

const de_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool-Integrationen`)
};

const es_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraciones de herramientas`)
};

const fr_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrations d'outils`)
};

const pt_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrações de ferramentas`)
};

const zh_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具集成`)
};

const tr_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araç entegrasyonları`)
};

const ru_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интеграция инструментов`)
};

const pl_svc_ai_agent_development_tools_title5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integracje narzędzi`)
};

/**
* | output |
* | --- |
* | "Tool integrations" |
*
* @param {Svc_Ai_Agent_Development_Tools_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_tools_title5 = /** @type {((inputs?: Svc_Ai_Agent_Development_Tools_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Tools_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "de") return de_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "es") return es_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_tools_title5(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_tools_title5(inputs)
	return en_svc_ai_agent_development_tools_title5(inputs)
});
export { svc_ai_agent_development_tools_title5 as "svc_ai-agent-development_TOOLS_title" }